import { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";

import { submitQuizQuestion, submitTournamentQuizQuestion } from "sj-ui-toolkit/src/api";
import { C, themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { useLearnContext } from "../../../../../context/LearnContext";
import FeedbackPage from "../../../../Feedback/FeedbackPage";

import S from "./_styles.module.scss";

export default function QuizQuestion({ question, answersCount, questionsCount, onContinue }) {
  const { isTournament } = useLearnContext();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submissionData, setSubmissionData] = useState(null);
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);

  const onSubmit = async () => {
    try {
      setIsFeedbackLoading(true);
      if (isTournament) {
        const data = await submitTournamentQuizQuestion({
          slug: selectedOption,
          questionId: question.assessmentQuestionId,
        });
        setSubmissionData(data);
      } else {
        const data = await submitQuizQuestion({
          slug: selectedOption,
          questionId: question.assessmentQuestionId,
        });
        setSubmissionData(data);
      }
      setIsFeedbackLoading(false);
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error submitting quiz question:", error);
    }
  };
  const handleContinue = () => {
    onContinue(submissionData);
    setSelectedOption(null);
    setIsSubmitted(false);
    setSubmissionData(null);
  };

  return (
    <>
      <h2 className="atlas-h5 p-4 text-muted">
        Question {answersCount + 1} of {questionsCount}
      </h2>
      <div className={S.quizBody}>
        <span className="body-lg">{question.text}</span>
        <fieldset className="flex flex-col gap-4">
          {question.answers.map((answer, index) => (
            <div key={index}>
              <label className="flex items-center gap-2">
                <RadioButton
                  inputId={`radio-${index}`}
                  value={answer.slug}
                  checked={selectedOption === answer.slug}
                  onChange={() => setSelectedOption(answer.slug)}
                  aria-describedby={`answer-description-${index}`}
                  data-testid={`mc-answer-${index}`}
                />
                {answer.text}
              </label>
              <span id={`answer-description-${index}`} className={S.visuallyHidden}>
                {answer.choice} vulnerability.
              </span>
            </div>
          ))}
        </fieldset>
        {submissionData?.feedback && (
          <div
            className={C("flex items-center gap-2 p-4 w-fit rounded-sm", themeClasses.bgElevation3)}
          >
            {submissionData.isCorrect ? (
              <i className="pi pi-check text-success"></i>
            ) : (
              <i className="pi pi-times text-danger"></i>
            )}
            <span>{submissionData.feedback}</span>
          </div>
        )}
      </div>
      <div className={S.quizFooter}>
        <div className="flex justify-between">
          <Button
            label="Provide question feedback"
            link
            onClick={() => setFeedbackModalVisible(true)}
          />
          {isSubmitted ? (
            <Button label="Continue" onClick={handleContinue} />
          ) : (
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={onSubmit}
              disabled={!selectedOption}
              loading={isFeedbackLoading}
            />
          )}
        </div>
      </div>

      <Dialog
        header="Feedback"
        visible={feedbackModalVisible}
        onHide={() => setFeedbackModalVisible(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      >
        <FeedbackPage forQuiz={true} />
      </Dialog>
    </>
  );
}
